export default {"src":"/_next/static/media/holzweiler.bd4a9bc8.svg","height":80,"width":184,"blurWidth":0,"blurHeight":0};